import { render, staticRenderFns } from "./ChooseChapterStep2.vue?vue&type=template&id=9d0cd654&scoped=true&"
import script from "./ChooseChapterStep2.vue?vue&type=script&lang=js&"
export * from "./ChooseChapterStep2.vue?vue&type=script&lang=js&"
import style0 from "./ChooseChapterStep2.vue?vue&type=style&index=0&id=9d0cd654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0cd654",
  null
  
)

export default component.exports